import React from 'react';
import Loading from '../Loading/Loading';

const LoadingPage = () => {
  return (
    <div className="flex justify-center items-center h-full mt-theme-top-bar-negative-height">
      <Loading />
    </div>
  );
};

export default LoadingPage;
